import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { useGlobalContext } from "../context";
import ExamButton from "./ExamButton";
import Loading from "./Loading";

const ExamsIndexPage = () => {
  const { apiClient, me, user } = useGlobalContext();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [selectedExam, setSelectedExam] = React.useState({});
  const [fullName, setFullName] = React.useState(user.fullName);
  const [identifier, setIdentifier] = React.useState(user.idNumber);
  const [registrationDate, setRegistrationDate] = React.useState("");
  const closeRef = React.useRef(null);

  useEffect(() => {
    setRegistrationDate(selectedExam.registrationDate);
  }, [selectedExam]);

  async function createEntry(e) {
    e.preventDefault();
    if (!selectedExam) {
      alert("Please select an exam first.");
      return;
    }
    if (!fullName) {
      alert("Please enter your full name.");
      return;
    }
    if (!registrationDate) {
      alert("Please enter the registration date.");
      return;
    }
    closeRef.current.click();
    try {
      setLoading(true);
      const res = await apiClient.put("/exams/start", {
        fullName,
        registrationDate,
        id: selectedExam.id,
        idNumber: identifier,
      });
      await me();
      history.push(`/exam/${res.data.exam}`);
    } catch (error) {
      alert(error);
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <div className="d-flex flex-column">
        <h1 className="display-5 text-muted">Select A Course Final</h1>
        {!user.entries.length ? (
          <h6>
            You don't have any exams. Please contact to school or{" "}
            <a href="/certificate">print my certificates.</a>
          </h6>
        ) : (
          user.entries.map((e, i) => (
            <ExamButton
              e={e}
              i={i}
              key={e.id}
              setSelectedExam={setSelectedExam}
            />
          ))
        )}
        <div className="mt-5">
          <h4>A Fair Housing Game and Implicit Bias</h4>
          <a
            href="https://www.realtypublications.com/bulk_practice/?adsource=6195"
            className="fs-5"
          >
            Click Here To Start
          </a>
        </div>
        <div className="my-5 p-3 bg-light rounded border">
          <h4>Test Taking Strategy</h4>
          <h6 className="mb-1">Round 1."The Lightning Round"</h6>
          <p>
            Starting from question 1, go through the entire exam and answer the
            questions that you feel you are absolutely sure you know the answer
            to (quickly), skipping over all of the ones you do not.
          </p>
          <h6 className="mb-1">Round 2. "Analyze"</h6>
          <p>
            Going back to beginning of exam, go through and answer the questions
            you skipped over and had an idea what the answer was, spending a
            couple of minutes on each one.
          </p>
          <h6 className="mb-1">Round 3. "Open Book"</h6>
          <p>
            For remaining unanswered questions, take this time to look for
            answers in the book.
          </p>
          <h6 className="mb-1">Round 4. "Guess"</h6>
          <p>
            Saving a small segment of time for any questions you could not find
            answers in the book... just take your best guess!
          </p>
        </div>
      </div>
      <div
        className="modal fade"
        id="detailsModal"
        tabIndex="-1"
        aria-labelledby="detailsModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="detailsModalLabel">
                Provide Your Identification
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeRef}
              ></button>
            </div>
            <form onSubmit={createEntry}>
              <div className="modal-body">
                <p>
                  Enter your government issued ID number below. (Drivers Lic, ID
                  Card as example) By clicking "Agree", I hereby declare under
                  penalty and perjury that this information is true (accurate)
                  and that I'm the only person that will be accessing the course
                  finals.
                </p>
                <div className="mb-3">
                  <label htmlFor="full-name-input" className="form-label">
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="full-name-input"
                    name="fullName"
                    className="form-control form-control-sm"
                    required={true}
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="id-input">ID Number</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                  />
                </div>
                {!selectedExam.registrationDate && (
                  <div>
                    <label htmlFor="registration-date-input" className="m-0">
                      Date of Enrollment in Course
                    </label>
                    <p className="form-text mt-0 mb-1">(Not Todays Date)</p>
                    <input
                      type="date"
                      id="registration-date-input"
                      name="registrationDate"
                      className="form-control form-control-sm"
                      required={true}
                      value={registrationDate}
                      onChange={(e) => setRegistrationDate(e.target.value)}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex p-3 justify-content-end">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-success px-4 ms-2"
                >
                  Enter
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExamsIndexPage;
